module.exports = __webpack_public_path__ + "static/bg-texture-wide-a89c891acb0f53e18feb0587d7723c90.jpg";